import { PromotionCodeComboBoxModel } from '../promotion-code-combo-box.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * プロモーションコードリストを取得する
 *
 * @export API通信成功時の処理
 * @class GetPromotionCodeListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetPromotionCodeListService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private model: PromotionCodeComboBoxModel;
  private codeDiv: string = null;
  private reserve1: string = null;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPromotionCodeListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        CodeDiv: this.codeDiv,
        Reserve1: this.reserve1
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {CodeComboBoxModel} model
   * @param {string} orderCode
   * @param {string} reserve1
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetPromotionCodeListService
   */
  execute(model: PromotionCodeComboBoxModel, codeDiv: string, reserve1: string, successFunc: Function = null) {
    this.model = model;
    this.codeDiv = codeDiv;
    this.reserve1 = reserve1;
    this.successFunc = successFunc;
    this.send('KYMW02getPromotionCodeList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCodeListService
   */
  success(data: any) {
    this.model.updateCodeList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
